export default {"src":"/_next/static/media/mana13.a6be8863.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};